import React from 'react';
import { Box, Text, IconButton, Tooltip } from '@chakra-ui/react';
import { XCircle } from 'phosphor-react';
import { formatCurrency } from '../../../utils/FormatFunctions';

export interface TaxCardProps {
  title: string;
  value: number;
  color: string;
  filterKey?: string;
  isFiltering?: boolean;
  onClick?: () => void;
  onRemoveFilter?: () => void;
}

export const TaxCard: React.FC<TaxCardProps> = ({
  title,
  value,
  color,
  filterKey,
  isFiltering = false,
  onClick,
  onRemoveFilter,
}) => (
  <Box
    bg="white"
    p={{ base: 2, md: 4 }}
    borderRadius="lg"
    boxShadow={isFiltering ? 'lg' : 'md'}
    borderLeft="4px solid"
    borderLeftColor={color}
    border={isFiltering ? '2px solid' : undefined}
    borderColor={isFiltering ? color : undefined}
    cursor={filterKey ? 'pointer' : 'default'}
    transition="all 0.2s"
    _hover={filterKey ? { transform: 'scale(1.02)', boxShadow: 'lg' } : undefined}
    onClick={onClick}
    position="relative"
  >
    <Text
      fontSize={{ base: '2xs', md: 'xs' }}
      color="gray.500"
      textTransform="uppercase"
      fontWeight="semibold"
      noOfLines={1}
    >
      {title}
    </Text>
    <Text fontSize={{ base: 'sm', md: 'lg' }} fontWeight="bold" color="gray.700">
      {formatCurrency(value)}
    </Text>
    {isFiltering && onRemoveFilter && (
      <Tooltip label="Remover filtro" hasArrow>
        <IconButton
          aria-label="Remover filtro"
          icon={<XCircle size={16} weight="fill" />}
          size="xs"
          variant="ghost"
          position="absolute"
          top={1}
          right={1}
          color="gray.400"
          _hover={{ color: 'red.500' }}
          onClick={e => {
            e.stopPropagation();
            onRemoveFilter();
          }}
        />
      </Tooltip>
    )}
  </Box>
);
